/* ftb-jersey-hero-3d - lazy hydration + viewport-gated playback
 *
 * Contract with sections/ftb-jersey-hero-3d.liquid:
 *   - <video data-ftb-jhero-video preload="none" muted loop playsinline poster=...>
 *   - its <source> elements carry data-src, NOT src
 * Nothing about the video is fetched until this script moves data-src -> src, so a
 * visitor who never scrolls to the section downloads zero video bytes, and the
 * reduced-motion path downloads nothing at all.
 *
 * Deliberately has no dependency on the theme's global.js DeferredMedia: that class
 * is click-to-load and unmutes, which is the opposite of an ambient background loop.
 */
(function () {
  'use strict';

  var SELECTOR = 'video[data-ftb-jhero-video]';

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* Move data-src -> src exactly once, then let the element load. */
  function hydrate(video) {
    if (video.dataset.ftbHydrated === '1') return;
    video.dataset.ftbHydrated = '1';

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }
    video.load();
  }

  /* play() rejects on its own (autoplay policy, decode error, tab backgrounded).
     Swallowing it is correct here: the poster stays on screen and the section still
     reads as intended. Letting it reject unhandled would surface as a console error,
     which the deploy protocol gates on. */
  function play(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {});
    }
  }

  function activate(video) {
    hydrate(video);
    play(video);
  }

  function deactivate(video) {
    if (video.dataset.ftbHydrated !== '1') return;
    if (!video.paused) video.pause();
  }

  function observe(video) {
    /* No IntersectionObserver (or the section is already on screen in a browser that
       lacks it): hydrate immediately rather than leave a dead poster. */
    if (!('IntersectionObserver' in window)) {
      activate(video);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            activate(entries[i].target);
          } else {
            deactivate(entries[i].target);
          }
        }
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    io.observe(video);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll(SELECTOR);

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (video.dataset.ftbInit === '1') continue;
      video.dataset.ftbInit = '1';

      /* Reduced motion: never fetch, never play. The poster is the final state. */
      if (prefersReducedMotion()) continue;

      observe(video);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme Editor: a section re-render replaces the DOM node, so re-init its subtree. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* Theme Editor: stop a loop that is being scrolled away from / hidden. */
  document.addEventListener('shopify:section:unload', function (event) {
    var videos = event.target.querySelectorAll
      ? event.target.querySelectorAll(SELECTOR)
      : [];
    for (var i = 0; i < videos.length; i++) deactivate(videos[i]);
  });
})();
